import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import packageSmsApis from '../../../../services/packageSmsApis';
import dayjs from 'dayjs';
import { IGetSummaryReportVoiceResponse } from '../../interfaces/apis';

const DEFAULT_PARAMS = {
  shopId: undefined,
  startDate: dayjs().subtract(7, 'day').format('MM-DD-YYYY'),
  endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
};

const useGetSummaryReportVoice = () => {
  const [data, setData] = useState<IGetSummaryReportVoiceResponse | null>(null);
  const [params, setParams] = useState(DEFAULT_PARAMS);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IGetSummaryReportVoiceResponse }> = await packageSmsApis.getSummaryVoice({
        shopId: params.shopId ? params.shopId : undefined,
        startDate: dayjs(params.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(params.endDate).format('MM-DD-YYYY'),
      });
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching SMS package dashboard:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [params]);

  return { data, loading, params, setParams };
};

export default useGetSummaryReportVoice;
